// extracted by mini-css-extract-plugin
export var actions = "_3l-0";
export var actionsContainer = "_3l-7";
export var border = "_3l-1";
export var childFullHeight = "_3l-f";
export var collapse = "_3l-2";
export var content = "_3l-a";
export var contentChild = "_3l-e";
export var fullscreen = "_3l-c";
export var hasLeftRadius = "_3l-k";
export var headerContainer = "_3l-3";
export var headerRow = "_3l-5";
export var hidePadding = "_3l-b";
export var navCollapsedGap = "_3l-l";
export var noScrollX = "_3l-m";
export var noScrollY = "_3l-n";
export var noTopPadding = "_3l-i";
export var optOutTopPadding = "_3l-d";
export var pageMain = "_3l-j";
export var pageOuter = "_3l-g";
export var pagePadding = "_3l-8";
export var pageScroll = "_3l-9";
export var profile = "_3l-o";
export var profileContainer = "_3l-p";
export var profileImage = "_3l-q";
export var profileMain = "_3l-r";
export var profileSubtitle = "_3l-t";
export var profileTitle = "_3l-s";
export var showLeftPadding = "_3l-h";
export var tabsPortalSlot = "_3l-6";
export var tabsWrapper = "_3l-4";
export var title = "_3l-u";